export const citiesSF = [
    'Москва', 'Санкт-Петербург', 'Казань', 'Нижний Новгород', 'Новосибирск', 'Красноярск', 'Екатеринбург', 'Тюмень', 'Краснодар', 'Ростов-на-Дону', 'Сочи', 'Челябинск'
]

export const marketsSF = [
    'Яндекс Лавка', 'Яндекс Лавка XL', 'ВкусВилл', 'Жизнь март', 'Перекрёсток.Доставка', 'Азбука Вкуса', 'Ozon Fresh',  'Табрис', 'Добрянка'

]
export const levels: { [key: string]: string } = {
    level_1_samokat_values: 'Левел 1 Самокат',
    level_3_samokat_values: 'Левел 3 Самокат',
    category_1_level_values: 'Категория (1 уровень)',
    category_2_level_values: 'Категория (2 уровень)',
    category_3_level_values: 'Категория (3 уровень)',
}